import { Drawer } from '@toggle/design-system';
import { useDisableScroll } from '@toggle/helpers';
import { SingleNews } from '@toggle/toggle';
import React from 'react';

import { NewsBadges } from '~/components/news-badges/NewsBadges';

import { ArticleDrawerContent } from './ArticleDrawerContent';
import { useSingleNews } from './hooks/use-single-news/useSingleNews';

export interface ArticleDrawerProps {
  list?: SingleNews[];
  newsId: string;
  onClick?: (singleNews: SingleNews) => void;
  onClose: () => void;
}

export const ArticleDrawer = ({
  list = [],
  newsId,
  onClick,
  onClose,
}: ArticleDrawerProps) => {
  useDisableScroll();

  const initialNews = list.find(item => item.id === newsId);
  const { data, isError, isFetching } = useSingleNews(newsId, initialNews);

  return (
    <Drawer
      isOpen
      data-testid="article-drawer"
      handleCloseClick={onClose}
      headerButton={
        data && (
          <NewsBadges highlights={data.highlights} entityTags={data.entities} />
        )
      }
    >
      <ArticleDrawerContent
        isError={isError}
        isFetching={isFetching}
        data={data}
        list={list}
        onArticleClick={onClick}
        onClose={onClose}
        newsId={newsId}
      />
    </Drawer>
  );
};
